// FE-098 (DEC-268, piano S2-28): le regole dei pulsanti del dettaglio di un
// preventivo e del menu dell'aliquota IVA, fuori dal componente così le prove
// jest le controllano direttamente.

// «Modifica» si nasconde solo quando il preventivo è diventato un cantiere
// (stato «convertito»): modificarlo dopo scollegherebbe gli importi dal
// cantiere nato da lui. Una bozza solo COLLEGATA a un cantiere già esistente
// (preventivi dettati a voce) resta modificabile. Prima (FE-077) bastava il
// collegamento per nasconderlo.
export function puoModificare(preventivo) {
  return Boolean(preventivo) && preventivo.stato !== 'convertito';
}

// Testo del pulsante verso il cantiere collegato (Q1 (a)): «Cantiere aperto»
// solo se il cantiere è nato dal preventivo, altrimenti «Vai al cantiere».
export function etichettaCantiere(preventivo) {
  return preventivo && preventivo.stato === 'convertito' ? 'Cantiere aperto ↗' : 'Vai al cantiere ↗';
}

// L'aliquota come la scrive il menu: il server la manda come «22.00»
// (DecimalField), le voci del menu sono «22». Vuota → 22, come un preventivo
// nuovo. Un testo non numerico resta com'è: il menu lo mostra come voce in più.
export function aliquotaNormalizzata(valore) {
  const testo = String(valore == null ? '' : valore).trim().replace(',', '.');
  if (testo === '') return '22';
  const numero = Number(testo);
  return Number.isFinite(numero) ? String(numero) : testo;
}

// Le voci del menu più, se serve, quella dell'aliquota salvata che non è
// nell'elenco (Q2 (a)): «21% (salvata)». Così il menu dice il vero e salvare
// senza toccarlo non cambia l'aliquota.
export function opzioniAliquota(elenco, valore) {
  const attuale = aliquotaNormalizzata(valore);
  if (elenco.some((a) => String(a.v) === attuale)) return elenco;
  return [...elenco, { v: attuale, l: `${attuale}% (salvata)` }];
}
